import { render, staticRenderFns } from "./ConsentTitle.vue?vue&type=template&id=e16d0410"
import script from "./ConsentTitle.vue?vue&type=script&lang=ts"
export * from "./ConsentTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports